<script>
import RadioGroup from '../Form/RadioGroup.vue';
import {hasEditPermission,currentRoleLevelName,trialActiveForClients} from '@/mixins/roleLevelPermissions';
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { mapState } from 'vuex';
// import agreementValidation from '@/mixins/agreementValidation'

export default {
	components: { RadioGroup },
	// mixins: [roleLevelPermissions],
	props: ['partnerData', 'title', 'partner', 'id','agreementData'],
	mixins:[validationMixin],
	methods:{
		validateState(name) {
			const { $dirty, $error } = this.$v.partnerData[name];
			return $dirty ? !$error : null;
		},
		triggerValidation(){
			this.$v.$touch();
			this.$refs["partner-address"].triggerValidation();
			this.$refs["pronouns-ref"].triggerValidation()
		}
	},
	validations:{
		partnerData:{
			birthdate:{
				required
			},
			pronouns:{
				required
			}
		}
	},
	data(){
		return{
			// label: this.clientUserAgreement ? 'Are you retired?':'Is this party retired?' ,
			isViewMode : (this.partner == 'party2') ? !hasEditPermission('section-other-partner-details') : false,
			showLearnButton: ['client-level-1', 'client-level-2'].includes(currentRoleLevelName)
		};
	},
	computed:{
		...mapState(['currentRoleLevel']),
		clientUserAgreement(){
			// return currentRoleLevelName == 'client-sharing-user' ? true : false;
			return trialActiveForClients() || currentRoleLevelName === 'client-sharing-user';
		},
		toolTipText(){
			if(this.partner ==='party1'){
				return {
					address: "Use the address where you reside now (where you are receiving your mail).",
					birthdate: 'You may use the datepicker or manually enter the numbers with the "-" between each number entry (eg. 02-24-2002)',
					occupation: 'Your entry should not include any articles like a/an/the. Finish the sentence "I am a/an __________"',
					pronouns: "Choose the pronouns that best describe your preferred pronouns.",
					income: `What are you likely to earn over the next 12 months? What income do you have accessible to you?
						Looking at your last income tax return may be a good resource, but sometimes it is not.
						Consider how your last income tax return might be different next year? Would you have a new job?
						Did you get a raise? Different hours? Rental income? Investment income?`,
					incomeReason:`The law requires full financial disclosure of documents and other income information. For further information on financial disclosure see the video on Creating Strong Separation Agreements in the Knowledge Base.
						For more information on Determining Income, see the Determining Income in the Knowledge Base in the Child Support and Spousal Support sections.<br/> 
						<b>By Verifying Income Tax Returns and Other Documents</b> Chose this option if you and your spouse exchanged income documentation and used the figures as a basis for determining income<br/>
						<b>By Agreement</b> Choose this option if you and your spouse agreed to use another figure that is not reflective of your income documentation<br/>
						<b>By Imputation</b> Choose this option if you and your spouse agreed to impute an income to you.`,
					incomeDisclosure: `The law requires full financial disclosure of documents and other income information. For further information on financial disclosure see the video on Creating Strong Separation Agreements in the Knowledge Base.  
						If you don't fully disclose financial information and documents, we will write the appropriate clauses in for you outlining that you chose not to do so and that you and your spouse are entering into the agreement in light of this.  
						If you did provide full financial disclosure, we will add the appropriate clauses that outline that you each acknowledge that you had a transparent and fair exchange of information to make your agreement.
						This will make your agreement stronger and more reliable (less likely to be overturned)`,
					hasLegalCounsel:`Getting independent legal advice ("ILA") is very important to make sure you understand your legal rights and obligations and understand the content of the agreement before you sign.
						For more information, see the video on Creating Strong Separation Agreements in the Knowledge Base.
						If you have received ILA or will be getting it, choose "Yes" and we will insert the name of your lawyer and a Certificate of Independent Legal Advice for them to sign.`,
					includeCertificateOfIndependantLegalAdvice: `We recommend including a Certificate of Independent Legal Advice ("CILA").
						A CILA is a certificate that is signed by your lawyer that affirms that they
						met with you and explained the agreement to you and that you understood your rights, potential issues, and consequences of the agreement.`
				}
			}else{
				return {
					address: "Use the address where your spouse resides now (where they are receiving their mail).",
					birthdate: 'You may use the datepicker or manually enter the numbers with the "-" between each number entry (eg. 02-24-2002)',
					occupation: 'Your entry should not include any articles like a/an/the. Finish the sentence "My spouse is a/an __________"',
					pronouns: "Choose the pronouns that best describe your spouse's preferred pronouns.",
					income: `What is your spouse likely to earn over the next 12 months?
						What income do they have accessible to them? Looking at their last income tax return may be a good resource,
						but sometimes it is not. Consider how their last income tax return might be different next year? Would they have a new job? Did they get a raise? Different hours? Rental income? Investment income?`,
					incomeReason:`The law requires full financial disclosure of documents and other income information.
						For further information on financial disclosure see the video on Creating Strong Separation Agreements in the Knowledge Base.  For more information on Determining Income,
						see the Determining Income in the Knowledge Base in the Child Support and Spousal Support sections.<br/>
						<b>By Verifying Income Tax Returns and Other Documents</b> Chose this option if you and your spouse exchanged income documentation and used the figures as a basis for determining income<br/>
						<b>By Agreement</b> Choose this option if you and your spouse agreed to use another figure that is not reflective of your income documentation<br/>
						<b>By Imputation</b> Choose this option if you and your spouse agreed to impute an income to you`,
					incomeDisclosure: `The law requires full financial disclosure of documents and other income information. For further information on financial disclosure see the video on Creating Strong Separation Agreements in the Knowledge Base.  
						If you don't fully disclose financial information and documents, we will write the appropriate clauses in for you outlining that you chose not to do so and that you and your spouse are entering into the agreement in light of this.  
						If you did provide full financial disclosure, we will add the appropriate clauses that outline that you each acknowledge that you had a transparent and fair exchange of information to make your agreement.
						This will make your agreement stronger and more reliable (less likely to be overturned)`,
					hasLegalCounsel:`Getting independent legal advice ("ILA") is very important to make sure your spouse understands their legal rights and obligations and understand the content of the agreement before they sign.
						For more information, see the video on Creating Strong Separation Agreements in the Knowledge Base.
						If they have received ILA or will be getting it, choose 'Yes' and we will insert the name of their lawyer and a Certificate of Independent Legal Advice for them to sign.`,
					includeCertificateOfIndependantLegalAdvice: `We recommend including a Certificate of Independent Legal Advice ("CILA").
						A CILA is a certificate that is signed by your spouse's lawyer that affirms that the lawyer met with them and explained the agreement to them and that they understood their rights, potential issues, and consequences of the agreement.`
				}
			}
		},
		isUserSeparatingParty(){
			return this.currentRoleLevel.roleAssociated === 'party'
		},
		dynamicQuestions(){
			if(this.isUserSeparatingParty){
				if(this.partner ==='party1'){
					return {
						employed:`Is ${this.partnerData.name.first} employed or self-employed?`,
						occupation:`What is ${this.partnerData.name.first}'s occupation?`,
						income:`What is ${this.partnerData.name.first}'s income from all sources?`,
						incomeReason:`How did you determine ${this.partnerData.name.first}'s income?`,
						incomeDisclosure:`Did ${this.partnerData.name.first} fully disclose all aspects of ${this.partnerData.name.first}'s income to ${this.agreementData?.partner2?.name?.first}?`,
						hasLegalCounsel:`Will ${this.partnerData.name.first} be getting legal advice before signing this Agreement?`,
						includeCertificateOfIndependantLegalAdvice:`Would ${this.partnerData.name.first} like to include a certificate of independent legal advice?`,
						retired:`Is ${this.partnerData.name.first} retired?`
					}
				}
				else{
					return {
						employed:`Is ${this.partnerData.name.first} employed or self-employed?`,
						occupation:`What is ${this.partnerData.name.first}'s occupation?`,
						income:`What is ${this.partnerData.name.first}'s income from all sources?`,
						incomeReason:`How did you determine ${this.partnerData.name.first}'s income?`,
						incomeDisclosure:`Did ${this.partnerData.name.first} fully disclose all aspects of ${this.partnerData.name.first}'s income?`,
						hasLegalCounsel:`Will ${this.partnerData.name.first} be getting legal advice before signing this Agreement?`,
						includeCertificateOfIndependantLegalAdvice:`Would ${this.partnerData.name.first} like to include a certificate of independent legal advice?`,
						retired:`Is ${this.partnerData.name.first} retired?`
					}
				}
			}
			else{
				return {
					employed: "Is this party employed?",
					occupation:"Occupation",
					income:"Gross Income",
					incomeReason:"How did the parties determine income?",
					incomeDisclosure:"Did this party fully disclose their income information to the other party?",
					hasLegalCounsel:"Is this party represented by a lawyer?",
					includeCertificateOfIndependantLegalAdvice:"Would you like to include a certificate of legal advice?",
					retired:'Is this party retired?'

				}
			}
		}
	}
};
</script>

<template>
	<b-card :id="id">
		<div slot="header" class="section-heading">
			<h4>{{ title }}</h4>
			<a v-if="this.showLearnButton && partner === 'party1'" href="#" onclick="Intercom('showArticle', 12885471)">Learn &nbsp;<b-icon-book/></a>
			<a v-if="this.showLearnButton && partner === 'party2'" href="#" onclick="Intercom('showArticle', 12885489)">Learn &nbsp;<b-icon-book/></a>
		</div>

		<address-input-group ref="partner-address" :isValidationOn="true" v-model="partnerData.address" class="mb-3" :testid="partner+'-address'" :disabled="isViewMode" :toolTipText="toolTipText.address"/>

		<date-input
			v-model="$v.partnerData.birthdate.$model"
			label="Birthdate"
			class="mb-3"
			:testid="partner+'-dob'"
			:disabled="isViewMode"
			:isDateFilled="validateState('birthdate')"
			:isValidationOn="true"
			:toolTipText="toolTipText.birthdate"
		/>
		<div
			v-if="$v.partnerData.birthdate.$error"
			class="invalid-feedback d-block col-12"
		>
			This is a required field.
		</div>
		
		<radio-group
			v-model="$v.partnerData.pronouns.$model"
			class="mb-3"
			select
			input-cols="2"
			label="Pronouns"
			:options="[
				{ text: 'He/Him/His', value: 'male' },
				{ text: 'She/Her/Hers', value: 'female' },
				{ text: 'They/Them/Their', value: 'neutral' },
			]"
			:testid="partner+'-pronouns'"
			:validation="true"
			ref="pronouns-ref"
			:disabled="isViewMode"	
			:toolTipText="toolTipText.pronouns"			
		/>

		<input-group
				v-model="partnerData.mail"
				reset-undefined
				class="mb-2"
				input-cols="8"
				label="Email"
				:testid="partner+'-email'"
				:disabled="isViewMode"
		/>
		<yes-no-choice
			v-model="partnerData.employed"
			:label="dynamicQuestions.employed"
			class="mb-3"
			:testid="partner+'-employed'"
			:disabled="isViewMode"
			cols="8"
		/>
		<!-- <b-form-group
			v-else
			id="input-employed"
			label="Are you employed?"
			label-for="employed"
			:disabled="isViewMode"
		>
			<b-form-select
				id="employed"
				v-model="partnerData.employed"
				:options="[
					{ text: 'Yes', value: true },
					{ text: 'No', value: false,
					},
				]"
				:data-testid="partner+'-employed'"
				class="col-lg-8"
				:disabled="isViewMode"
				:class="{ 'custom-disabled': isViewMode }"
			/>
		</b-form-group> -->
		<conditional-group
			class="my-3"
			:condition="partnerData.employed === true"
		>
				
			<input-group
				v-model="partnerData.occupation"
				class="mb-3"
				reset-undefined
				input-cols="8"
				:label="dynamicQuestions.occupation"
				:testid="partner+'-occupation'"
				:disabled="isViewMode"
				:toolTipText="toolTipText.occupation"
			/>
		</conditional-group>

		<conditional-group
			class="my-3"
			:condition="partnerData.employed === false"
		>			
			<yes-no-choice
				v-model="partnerData.retired"
				:label="dynamicQuestions.retired"
				class="mb-3"
				:testid="partner+'-retired'"
				:disabled="isViewMode"
			/>
		</conditional-group>
		
		<input-group
			v-model="partnerData.income"
			dollar
			:label="dynamicQuestions.income"
			class="mb-3"
			:testid="partner+'-gross-income'"
			:disabled="isViewMode"
			:toolTipText="toolTipText.income"
		/>
		<template v-if="!clientUserAgreement">
		<radio-group
			v-model="partnerData.incomeReason"
			class="mb-3"
			select
			input-cols="5"
			:label="dynamicQuestions.incomeReason"
			:options="[
				{ text: 'By verifying their Income Tax Returns and other documents', value: 'incomeTax' },
				{ text: 'By agreement', value: 'agreement' },
				{ text: 'By imputation', value: 'imputation' },
			]"
			:testid="partner+'-income-reason'"
			:length="'long'"
			:disabled="isViewMode"
			:toolTipText="toolTipText.incomeReason"
		/>
	
		<yes-no-choice
			v-model="partnerData.incomeDisclosure"
			:label="dynamicQuestions.incomeDisclosure"
			class="mb-3"
			:testid="partner+'-income-disclosure'"
			:disabled="isViewMode"
			:toolTipText="toolTipText.incomeDisclosure"
		/>

		<yes-no-choice
			v-model="partnerData.hasLegalCounsel"
			:label="dynamicQuestions.hasLegalCounsel"
			class="mb-3"
			:testid="partner+'-has-legal-counsel'"
			:disabled="isViewMode"
			:toolTipText="toolTipText.hasLegalCounsel"
		/>

		<conditional-group
			:condition="partnerData.hasLegalCounsel"
			@reset="partnerData.legalCounselFullName = undefined"
		>
			<input-group
				class="mb-2"
				v-model="partnerData.legalCounselFullName"
				input-cols="8"
				label="Name of Lawyer"
				:testid="partner+'-lawyer-name'"
				:disabled="isViewMode"
			/>
			<b-form-row>
				<b-col class="col-4">
					<input-group
						class="mb-2"
						v-model="partnerData.lawyerCity"
						input-cols="12"
						label="City"
						:testid="partner+'-lawyer-city'"
						:disabled="isViewMode"
					/>
				</b-col>
				<b-col class="col-4">
					<input-group
						class="mb-3"
						v-model="partnerData.lawyerProvince"
						input-cols="12"
						label="Province"
						:testid="partner+'-lawyer-province'"
						:disabled="isViewMode"
					/>
				</b-col>
			</b-form-row>
			
		</conditional-group>

		<yes-no-choice
			v-model="partnerData.includeCertificateOfIndependantLegalAdvice"
			:label="dynamicQuestions.includeCertificateOfIndependantLegalAdvice"
			class="mb-3"
			:testid="partner+'-certificate-of-legal-advice'"
			:disabled="isViewMode"
			:toolTipText="toolTipText.includeCertificateOfIndependantLegalAdvice"
		/>
		<additional-clauses v-model="partnerData.additionalClauses" :testid="partner+'-add-clause-'" :disabled="isViewMode" />
	</template>
	</b-card>
</template>
